(function () {

// The hero video is the point of the page, so it is not made to wait for an
// idle moment. It used to hydrate inside requestIdleCallback(timeout: 1200),
// which on a busy load meant the browser had not even been told the video's
// URL for over a second - before any of the (8-33MB) file had started to
// arrive. The poster still goes first: hydration is chained off the poster's
// own load below, so the LCP paint is never competing with video bytes.
const $ddd44212b889e5f9$var$scheduleAfterPaint = (callback)=>{
    requestAnimationFrame(()=>requestAnimationFrame(callback));
};
const $ddd44212b889e5f9$var$getConnection = ()=>navigator.connection || navigator.mozConnection || navigator.webkitConnection;
const $ddd44212b889e5f9$var$initWorkSingleHero = (hero)=>{
    if (hero.dataset.workSingleHeroInitialized === 'true') return;
    hero.dataset.workSingleHeroInitialized = 'true';
    const video = hero.querySelector('[data-work-hero-video]');
    const poster = hero.querySelector('[data-work-hero-poster]');
    if (!video) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = $ddd44212b889e5f9$var$getConnection();
    const slowConnection = connection && [
        'slow-2g',
        '2g'
    ].includes(connection.effectiveType);
    const saveData = Boolean(connection === null || connection === void 0 ? void 0 : connection.saveData);
    let hydrated = false;
    let pausedForVisibility = false;
    const playVideo = ()=>{
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(()=>{
        // Autoplay can be blocked. The optimized poster remains visible.
        });
    };
    const hydrateVideo = ()=>{
        if (hydrated || reducedMotion.matches || saveData || slowConnection) return;
        hydrated = true;
        video.querySelectorAll('source[data-src]').forEach((source)=>{
            source.src = source.dataset.src;
        });
        video.muted = true;
        // `preload` is "none" in the markup so that a save-data or reduced-motion
        // visitor, who never reaches this function, is never billed for the file.
        // Once we are committed to playing it, say so, or the browser fetches
        // only enough to satisfy the old hint and playback starts late.
        video.preload = 'auto';
        video.load();
        playVideo();
    };
    const scheduleHydration = ()=>{
        if (!reducedMotion.matches && !saveData && !slowConnection) $ddd44212b889e5f9$var$scheduleAfterPaint(hydrateVideo);
    };
    if (poster && !poster.complete) {
        poster.addEventListener('load', scheduleHydration, {
            once: true
        });
        poster.addEventListener('error', scheduleHydration, {
            once: true
        });
    } else scheduleHydration();
    video.addEventListener('playing', ()=>{
        hero.classList.add('is-video-ready');
    });
    document.addEventListener('visibilitychange', ()=>{
        if (!hydrated) return;
        if (document.hidden) {
            if (!video.paused) {
                pausedForVisibility = true;
                video.pause();
            }
            return;
        }
        if (pausedForVisibility && !reducedMotion.matches) {
            pausedForVisibility = false;
            playVideo();
        }
    });
    const handleReducedMotionChange = (event)=>{
        if (event.matches) {
            video.pause();
            hero.classList.remove('is-video-ready');
            return;
        }
        scheduleHydration();
    };
    if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', handleReducedMotionChange);
    else if (typeof reducedMotion.addListener === 'function') reducedMotion.addListener(handleReducedMotionChange);
};
function $ddd44212b889e5f9$export$bfbe956add2d4d63(root = document) {
    var _context_matches;
    const selector = '[data-component="work-single-hero"]';
    const context = root || document;
    const heroes = [];
    if (context.nodeType === 1 && ((_context_matches = context.matches) === null || _context_matches === void 0 ? void 0 : _context_matches.call(context, selector))) heroes.push(context);
    if (context.querySelectorAll) heroes.push(...context.querySelectorAll(selector));
    heroes.forEach($ddd44212b889e5f9$var$initWorkSingleHero);
}


const $8f91ec8149ae3059$var$runBlock = ()=>(0, $ddd44212b889e5f9$export$bfbe956add2d4d63)(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $8f91ec8149ae3059$var$runBlock, {
    once: true
});
else $8f91ec8149ae3059$var$runBlock();

})();
//# sourceMappingURL=work-single-hero.js.map
